<template>
  <v-layout
      row
      align-center
  >
    <v-flex
        class="pa-2 ma-1"
    >
      <v-card class="ma-1">
        <v-tabs
            v-model="tab"
            background-color="#EBEFFD"
            centered
            show-arrows
            icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1">
            Queue
            <v-icon>mdi-account-multiple</v-icon>
          </v-tab>
          <v-tabs-items v-model="tab">
            <v-tab-item
                :key="1"
                :value="'tab-1'"
            >
              <v-card>
                <v-card-title>{{ queue.name }}</v-card-title>
                <v-card-subtitle>{{ queue.description }}</v-card-subtitle>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    class="ma-1"
                ></v-text-field>
                <div v-if="qList.length > 0">
                  <v-data-table
                      :headers="headers"
                      item-key="id"
                      :items="qList"
                      :search="search"
                      dense
                      :sort-by="['status', 'queue_no']"
                      :sort-desc="[false, false]"
                      class="display-3 font-weight-medium"
                  >
                    <template v-slot:item.created_at="{ item }">
                      <span>{{ new Date(item.created_at).toLocaleTimeString() }}</span>
                    </template>
                    <template v-slot:item.called_at="{ item }">
                                            <span>{{
                                                item.called_at ? new Date(item.called_at).toLocaleTimeString() : ''
                                              }}</span>
                    </template>
                    <template v-slot:item.appointment_date="{ item }">
                      <span>{{ getFormattedTime(item.appointment_date, item.type) }}</span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <span>{{ getStatusName(item.status) }}</span>
                    </template>
                    <template v-slot:item.service_id="{ item }">
                      <span>{{ getServiceName(item.service_id) }}</span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div
                          v-if="item.status === 2"
                      >
                        <v-btn
                            small
                            class="mr-2"
                            @click="serving(item)"
                        >Serving
                        </v-btn>
                        <v-btn
                            small
                            class="mr-2"
                            @click="cancel(item)"
                        >Cancel
                        </v-btn>
                        <v-btn
                            small
                            class="mr-2"
                            @click="whatsapp(item)"
                        >WhatsApp
                        </v-btn>
                        <v-btn
                            small
                            class="mr-2"
                            @click="sms(item)"
                        >SMS
                        </v-btn>
                      </div>
                      <div
                          v-else-if="item.status === 1"
                      >
                        <v-btn
                            small
                            class="mr-2"
                            @click="complete(item)"
                        >Served
                        </v-btn>
                        <v-btn
                            small
                            class="mr-2"
                            @click="whatsapp(item)"
                        >WhatsApp
                        </v-btn>
                        <v-btn
                            small
                            class="mr-2"
                            @click="sms(item)"
                        >SMS
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'queue-admin',
  data: () => ({
    tab: null,
    qList: [],
    pastList: [],
    called: [],
    search: '',
    searchPast: '',
    exportdata: [],
    headers: [
      {
        text: 'Queue No.',
        align: 'start',
        value: 'queue_no',
      },
      {
        text: 'Service',
        value: 'service_id'
      },
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Phone No.',
        value: 'phone_no',
      },
      {
        text: 'Queue from',
        value: 'created_at',
      },
      {
        text: 'Appointment',
        value: 'appointment_date',
      },
      {
        text: 'Notify at',
        value: 'called_at',
      },
      {
        text: 'Status',
        value: 'status',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],
    services: [],
    breadcrumbsItems: '',
  }),
  props: ['outlet', 'queue'],
  methods: {
    create() {
      window.location.href = 'queue/create'
    },
    edit(q) {
      window.location.href = 'queue/' + q.id + '/admin'
    },
    whatsapp(ql) {
      let msg = this.formatMsg(ql);
      // https://web.whatsapp.com/send?phone=6598763203&amp;text=%5BQueue+No.+3%5D+Hi+Adrian+koh%2C+it%27s+your+turn+soon.Please+come+back+in+5mins+time.+If+you+missed+your+q+number+by+3+person%2C+please+get+a+new+queue+number.+Thank+you.&amp;source&amp;data&amp;app_absent

      window.open("https://web.whatsapp.com/send?phone=" + ql.phone_no + "&text=" + encodeURI(msg), "_blank");
      // window.open("https://wa.me/" + ql.phone_no + "?text=" + msg, "_blank");
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=notify&type=whatsapp')
          .then(response => {
            this.qList = response.data;
          });
    },
    sms(ql) {
      let msg = this.formatMsg(ql);
      // send sms
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=notify&type=sms', {
        msg: msg,
        to: ql.phone_no
      }).then(response => {
        this.qList = response.data;
      });
    },
    formatMsg(ql) {
      let displayQNo = this.queue.display_queue_no;
      let msg = this.queue.message ? this.queue.message : "Hi, it is your turn now";
      if (displayQNo) msg = '[Q No. ' + ql.queue_no + '] ' + msg;
      if (msg.includes('{name}')) {
        let name = ql.name ? ql.name : '';
        msg = msg.replaceAll('{name}', name);
      }
      return msg
    },
    serving(ql) {
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=1').then(response => {
        this.fetchQList()
      })
    },
    complete(ql) {
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=3').then(response => {
        this.fetchQList()
      });
    },
    cancel(ql) {
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=4').then(response => {
        this.fetchQList()
      });
    },
    getStatusName(s) {
      switch (s) {
        case 1:
          return 'Serving';
        case 2:
          return 'Queueing';
        case 3:
          return 'Served';
        case 4:
          return 'Cancelled';
      }
    },
    getServiceName(s) {
      console.log(s);
      let serviceName = '';
      if (this.services.length > 0) {
        this.services.forEach(function (item, index) {
          console.log(item, s);
          if (item.id === s) {
            serviceName = item.name
          }
        })
      }
      return serviceName
    },
    fetchQList() {
      axios.get('/queue/' + this.queue.id + '/list?filter=q')
          .then(response => {
            this.qList = Object.values(response.data);
          });
    },
    getFormattedTime(time, type = '') {
      if (type !== 'onsite') {
        return new Date(time.replace(' ', 'T')).toLocaleTimeString();
      }
      return '';
    }
  },
  beforeMount() {
    this.qList = [];
    this.appointmentList = [];
    axios.get('/queue/' + this.queue.id + '/list?filter=q')
        .then(response => {
          this.qList = Object.values(response.data);
        });
    axios.get('/queue/' + this.queue.id + '/list?filter=past')
        .then(response => {
          this.pastList = Object.values(response.data);
        });
    axios.get('/queue/' + this.queue.id + '/list?filter=export')
        .then(response => {
          this.exportdata = Object.values(response.data);
        });
    axios.get('/api/getServices?oid=' + this.outlet.id).then(response => {
      this.services = response.data
    });
    if (this.outlet.onsite_email) {
      this.headers.splice(4, 0, {
        text: "Email",
        value: "email"
      });
    }
  },
  mounted() {
    setInterval(function () {
      this.fetchQList()
    }.bind(this), 5000);
  }
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/QueueAdmin.vue